"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ShortcutBase_1 = require("./ShortcutBase");

var shortcuts_1 = require("../../../models/query/scenarioStatistics/shortcuts");

var scenarioStatistics_1 = require("../../../models/query/scenarioStatistics");

var PortfolioCompositeFundShortcut =
/** @class */
function (_super) {
  __extends(PortfolioCompositeFundShortcut, _super);

  function PortfolioCompositeFundShortcut(scenarioStatisticQuery) {
    return _super.call(this, scenarioStatistics_1.ScenarioStatisticShortcut.portfolioCompositeFund, shortcuts_1.ShortcutType.rootOptions, scenarioStatisticQuery) || this;
  }

  PortfolioCompositeFundShortcut.prototype.getRootOptions = function (shortcutOptions) {
    var _a = shortcutOptions.options,
        options = _a === void 0 ? {} : _a;
    var response = this.scenarioStatisticQuery.shortcuts.portfolio.getRootOptions(__assign(__assign({}, shortcutOptions), {
      options: {
        portfolio: {
          key: 'compositeFund',
          options: {
            compositeFund: options.portfolioCompositeFund
          }
        }
      }
    }));
    return response;
  };

  return PortfolioCompositeFundShortcut;
}(ShortcutBase_1.ShortcutBase);

exports.PortfolioCompositeFundShortcut = PortfolioCompositeFundShortcut;